import { render, staticRenderFns } from "./ComparatorChart.vue?vue&type=template&id=25de5c77&"
import script from "./ComparatorChart.vue?vue&type=script&lang=ts&"
export * from "./ComparatorChart.vue?vue&type=script&lang=ts&"
import style0 from "./ComparatorChart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports